import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISession } from '../../common/interfaces/Session.interface';

interface SessionState {
  isModalOpen: boolean;
  isModalOpenedForAdd: boolean;
  selectedSession: ISession | null;
  validationErrors: { [field: string]: string[] };
}

const initialState: SessionState = {
  isModalOpen: false,
  isModalOpenedForAdd: false,
  selectedSession: null,
  validationErrors: {},
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSelectedSession(state, action: PayloadAction<ISession | null>) {
      state.selectedSession = action.payload;
    },
    clearSelectedSession(state) {
      state.selectedSession = null;
    },
    openSessionModal(
      state,
      action: PayloadAction<{ isModalOpenedForAdd?: boolean } | undefined>
    ) {
      state.isModalOpen = true;
      state.isModalOpenedForAdd = action?.payload?.isModalOpenedForAdd ?? false;
    },
    closeSessionModal(state) {
      state.isModalOpen = false;
      state.isModalOpenedForAdd = false;
    },
    setValidationErrors(
      state,
      action: PayloadAction<{ field: string; errors: string[] }>
    ) {
      state.validationErrors[action.payload.field] = action.payload.errors;
    },
    clearValidationErrors(state, action: PayloadAction<string>) {
      delete state.validationErrors[action.payload];
    },
    clearAllValidationErrors(state) {
      state.validationErrors = {};
    },
  },
});

export const {
  setSelectedSession,
  clearSelectedSession,
  openSessionModal,
  closeSessionModal,
  setValidationErrors,
  clearValidationErrors,
  clearAllValidationErrors,
} = sessionSlice.actions;
export default sessionSlice.reducer;
